<template>
  <div class="row">
    <div class="col-md-12">
      <span>{{ contactName }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact-summary',
  props: {
    contact: Object
  },
  computed: {
    contactName() {
      let _name = ''
      if (this.contact !== undefined && this.contact !== null) {
        _name = `for ${this.contact.firstName} ${this.contact.lastName}`
      }
      return _name
    }
  }
}
</script>
